import { useState } from 'react';

export function Contato() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    empresa: '',
    mensagem: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6bjmlaohb161tfd7jq0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nome: '', email: '', telefone: '', empresa: '', mensagem: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <section id="contato" className="py-16 sm:py-24 lg:py-32 px-5 sm:px-8 lg:px-20 bg-dark">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-10 sm:gap-12 lg:gap-16">
          <div className="space-y-6 sm:space-y-8">
            <div className="space-y-3 sm:space-y-4">
              <span className="text-gold text-xs uppercase tracking-[0.3em] font-semibold">
                Entre em contato
              </span>
              <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
                Vamos construir juntos
              </h2>
            </div>

            <p className="text-base sm:text-lg lg:text-xl text-gray-300 leading-relaxed">
              Parcerias institucionais, patrocínios e novos projetos.
            </p>

            <div className="space-y-5 sm:space-y-6 pt-4 sm:pt-8">
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gold/10 rounded-full flex-shrink-0">
                  <i className="ri-mail-line text-gold text-lg sm:text-xl"></i>
                </div>
                <div>
                  <p className="text-xs sm:text-sm text-gray-400 uppercase tracking-wider mb-1">Email</p>
                  <a href="mailto:mansamusajh@gmail.com" className="text-white text-sm sm:text-base lg:text-lg hover:text-gold transition-colors duration-300 break-all">
                    mansamusajh@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gold/10 rounded-full flex-shrink-0">
                  <i className="ri-whatsapp-line text-gold text-lg sm:text-xl"></i>
                </div>
                <div>
                  <p className="text-xs sm:text-sm text-gray-400 uppercase tracking-wider mb-1">WhatsApp</p>
                  <a href="https://wa.me/5511983562550" className="text-white text-sm sm:text-base lg:text-lg hover:text-gold transition-colors duration-300">
                    +55 (11) 98356-2550
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gold/10 rounded-full flex-shrink-0">
                  <i className="ri-map-pin-line text-gold text-lg sm:text-xl"></i>
                </div>
                <div>
                  <p className="text-xs sm:text-sm text-gray-400 uppercase tracking-wider mb-1">Localização</p>
                  <p className="text-white text-sm sm:text-base lg:text-lg">São Paulo – Brasil</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-dark-light rounded-3xl p-6 sm:p-8 lg:p-10">
            <form onSubmit={handleSubmit} data-readdy-form id="contact_form" className="space-y-5 sm:space-y-6">
              <div>
                <label htmlFor="nome" className="block text-xs sm:text-sm text-gray-400 mb-2 uppercase tracking-wider">
                  Nome completo
                </label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-dark border border-gold/20 rounded-lg text-white text-sm focus:outline-none focus:border-gold transition-colors duration-300"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-xs sm:text-sm text-gray-400 mb-2 uppercase tracking-wider">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-dark border border-gold/20 rounded-lg text-white text-sm focus:outline-none focus:border-gold transition-colors duration-300"
                />
              </div>

              <div>
                <label htmlFor="telefone" className="block text-xs sm:text-sm text-gray-400 mb-2 uppercase tracking-wider">
                  Telefone
                </label>
                <input
                  type="tel"
                  id="telefone"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-dark border border-gold/20 rounded-lg text-white text-sm focus:outline-none focus:border-gold transition-colors duration-300"
                />
              </div>

              <div>
                <label htmlFor="empresa" className="block text-xs sm:text-sm text-gray-400 mb-2 uppercase tracking-wider">
                  Empresa / Instituição
                </label>
                <input
                  type="text"
                  id="empresa"
                  name="empresa"
                  value={formData.empresa}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-dark border border-gold/20 rounded-lg text-white text-sm focus:outline-none focus:border-gold transition-colors duration-300"
                />
              </div>

              <div>
                <label htmlFor="mensagem" className="block text-xs sm:text-sm text-gray-400 mb-2 uppercase tracking-wider">
                  Mensagem
                </label>
                <textarea
                  id="mensagem"
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-3 bg-dark border border-gold/20 rounded-lg text-white text-sm focus:outline-none focus:border-gold transition-colors duration-300 resize-none"
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full px-6 sm:px-8 py-3 sm:py-4 bg-gold text-black rounded-full text-xs sm:text-sm font-semibold uppercase tracking-wider hover:bg-gold-light transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Enviando...' : 'Enviar mensagem'}
              </button>

              {submitStatus === 'success' && (
                <div className="p-4 bg-green-500/10 border border-green-500/20 rounded-lg">
                  <p className="text-green-400 text-xs sm:text-sm text-center">Mensagem enviada com sucesso!</p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-lg">
                  <p className="text-red-400 text-xs sm:text-sm text-center">Erro ao enviar mensagem. Tente novamente.</p>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
